import './App.css';
// import Hex from './hex';

function Portfolio() {
  return (
    <div className="Portfolio">
      <header className="Portfolio-header">
        <div className="my-info">
          <div className="hex">
            <div className="hex-background">
              <img src="/images/my-photo-3-1st.jpeg" alt="myself-test"/>
            </div>
          </div>
          <h2 className="myName">Taylor Meyer</h2>
          <h3 className="myTitle">Front-End Developer</h3>
          <div className="linkedin">
            <a href="https://www.linkedin.com/in/taylor-meyer-0a1b0115a/" target="_blank" rel="noreferrer"> Follow me on Linkedin!</a>
          </div>
          <div className="email">
            <a href="mailto:taylormeyernola@gmail.com">Email me!</a>
          </div>
        </div>

        <div className="about-me">
          <p>Hello, interested readers! My name is Taylor, and I am currently a Front-End Engineer / Web Developer for Cerberus Agency, a digital branding agency based out of New Orleans. Excelling in both communication and comprehension, I work well in social / team environments. I am a gregarious person, often looking to spend my time around friends, family, colleagues, and often strangers. When I have some time to myself, you will normally find me watching Manchester City, Saints or Pelicans games with my dog, Wednesday, in my lap.</p>
        </div>


        {/* <div class="hex">
          <div class="hex-background">
            <img src="/images/my-photo-1.jpeg" alt="myself-test"/>
          </div>
        </div>
        
         <div class="hex">
          <div class="hex-background">
            <img src="/images/my-photo-2.jpeg" alt="myself-test"/>
          </div>
        </div>

         <div class="hex">
          <div class="hex-background">
            <img src="/images/my-photo-3-1st.jpeg" alt="myself-test"/>
          </div>
        </div>

         <div class="hex">
          <div class="hex-background">
            <img src="/images/my-photo-4-3rd.jpeg" alt="myself-test"/>
          </div>
        </div>

         <div class="hex">
          <div class="hex-background">
            <img src="/images/my-photo-5-3rd.jpeg" alt="myself-test"/>
          </div>
        </div> */}

      </header>
    </div>
  );
}

export default Portfolio;
